import { Container, Title, Text, Button, Stack, Center } from '@mantine/core';
import { Link } from 'react-router-dom';

/**
 * NotFoundPage
 *
 * Displayed when user navigates to a route that doesn't exist.
 * Provides clear messaging and a way to return to the home page.
 */
export default function NotFoundPage() {
  return (
    <Container size="sm" py="xl">
      <Center>
        <Stack align="center" gap="md">
          <Title order={1} c="dimmed" size={120} fw={900}>
            404
          </Title>
          <Title order={2}>Page Not Found</Title>
          <Text c="dimmed" ta="center" maw={500}>
            The page you're looking for doesn't exist or has been moved.
            Check the URL or return to the home page.
          </Text>
          <Button component={Link} to="/" variant="filled" size="lg" mt="md">
            Return Home
          </Button>
        </Stack>
      </Center>
    </Container>
  );
}
